<template>
    <div>
        <v-list dense tile>
            <v-list-item-group v-model="item" color="primary">
                <v-list-item v-for="(cat, index) in categories" :key="(cat.id)">
                    <template v-if="editOffset !== index">
                        <v-list-item-content class="pa-0" @click="startEditing(index)">
                            {{cat.name}}
                        </v-list-item-content>

                        <v-list-item-icon>
                            <v-icon medium @click="deleteCategory(cat.id)">mdi-delete</v-icon>
                        </v-list-item-icon>
                    </template>

                    <template v-if="editOffset===index">
                        <v-list-item-content class="pa-0" @keydown.esc="cancelEditing" @keydown.enter="updateCategory(cat.id)">
                            <v-text-field dense v-model="tempValue" required> {{ tempValue }}
                            </v-text-field>
                        </v-list-item-content>

                        <v-list-item-icon>
                            <v-icon medium @click="updateCategory(cat.id)">mdi-content-save</v-icon>
                            <v-icon medium @click="cancelEditing">mdi-close-circle</v-icon>
                        </v-list-item-icon>
                    </template>
                </v-list-item>

                <v-list-item v-for="(input, index) in inputs" :key="index">
                    <v-list-item-content class="pa-0">
                        <v-text-field dense v-model="input.one" required> {{ input.one }}
                        </v-text-field>
                    </v-list-item-content>
                    <v-list-item-icon justify="space-around">
                        <span class="group">                  
                            <v-icon medium @click="createCategory(index)" :disabled="input.one === ''">mdi-plus-circle</v-icon> 
                            <v-icon medium @click="deleteRow(index)">mdi-close-circle</v-icon>  
                        </span>                    
                    </v-list-item-icon>
                </v-list-item>
            </v-list-item-group>
        </v-list>

        <div class="text-center pt-2">
            <v-btn color="secondary" class="black--text" :disabled="disableAdd" small @click="addRow">إضافة تصنيف</v-btn>
        </div>

    </div>
</template>

<script>
    import {
        GET_CATEGORIES,
        ADD_CATEGORY,
        UPDATE_CATEGORY,
        DELETE_CATEGORY 
    } from '../graphql/Categories'

    export default {
        data() {
            return {
                item: -1,
                categories: '',
                disableAdd: false,
                editOffset: -1,
                tempValue: null,
                inputs: []
            }
        },
        apollo: {
            categories: {
                query: GET_CATEGORIES
            }
        },
        methods: {
            addRow() {
                this.disableAdd = true
                this.inputs.push({
                    one: ''
                })
            },
            deleteRow(index) {
                this.disableAdd = false
                this.inputs.splice(index, 1)
            },
            startEditing: function (index) {
                this.disableAdd = true
                this.editOffset = index;
                this.tempValue = this.categories[index].name
            },
            cancelEditing: function () {
                this.disableAdd = false
                this.editOffset = -1;
                this.tempValue = null;
            },
            createCategory(index) {
                this.$apollo.mutate({
                    mutation: ADD_CATEGORY,
                    variables: {
                        name: this.inputs[index].one,
                    },
                    update: (cache, {data: {createCategory} }) => {
                        //First read the query you want to update

                        const data = cache.readQuery({
                            query: GET_CATEGORIES
                        })

                        // Create updated data
                        data.categories.push(createCategory)
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_CATEGORIES,
                            data
                        })
                    },
                    // Ensures data is added immediately

                    optimisticResponse: {
                        __typename: 'Mutation',
                        createCategory: {
                            __typename: 'Category',
                            name: this.inputs[index].one
                        }
                    }

                }).then(({
                    data
                }) => {
                    this.disableAdd = false
                    this.inputs.splice(index, 1)
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            },
            updateCategory(id) {
                this.$apollo.mutate({
                    mutation: UPDATE_CATEGORY,
                    variables: {
                        id: id,
                        name: this.tempValue,
                    },
                    update: (cache, {data: { updateCategory }}) => {
                        //First read the query you want to update

                        const data = cache.readQuery({
                            query: GET_CATEGORIES
                        })

                        let index = data.categories.findIndex(category => category.id === updateCategory.id) 

                        let updatedCategories = [
                            ...data.categories.slice(0, index),
                            updateCategory,
                            ...data.categories.slice(index + 1)
                        ]
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_CATEGORIES,
                            data: updatedCategories
                        })
                    },
                    // Ensures data is added immediately

                    optimisticResponse: {
                        __typename: 'Mutation',
                        updateCategory: {
                            __typename: 'Category',
                            name: this.tempValue
                        }
                    }

                }).then(({data}) => {
                    this.disableAdd = false
                    this.editOffset = -1
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            },
            deleteCategory(id) {
                this.$apollo.mutate({
                    mutation: DELETE_CATEGORY,
                    variables: {
                        id: id
                    },
                    update: (cache, {data: { deleteCategory }}) => {
                        //First read the query you want to update
                        const data = cache.readQuery({
                            query: GET_CATEGORIES
                        })

                        let index = data.categories.findIndex(category => category.id === deleteCategory.id) 

                        data.categories.splice(index, 1)
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_CATEGORIES,
                            data
                        })
                    },

                }).then(({data}) => {
                    this.editOffset = -1
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            }
        }
    }
</script>

<style scoped>
  .tile {
    margin: 5px;
    border-radius: 4px;
  }
  .tile:hover {
    background: green;
  }
  .tile:active {
    background: yellow;
  }
</style>